import { OffsetModeViewEnum } from '@shared/utils/Trading/OffsetModeViewEnum';
import { OperationType } from '@shared/utils/Trading/OperationType';
import { MathUtils } from '@shared/utils/MathUtils';
import { NumericUtils } from '@shared/utils/NumericUtils';
import { SlTpUtils } from '@shared/utils/Trading/SlTpUtils';
import { getTradingNumericParameters } from '../TradingNumeric/TradingNumericUtils';
export function getSlTpNumericParameters(price, variableTickList, operationType, isSl, offsetType) {
    if (isNullOrUndefined(offsetType)) {
        return getTradingNumericParameters(variableTickList, price);
    }
    else if (offsetType === OffsetModeViewEnum.Percent) {
        const isBuy = operationType === OperationType.Buy;
        return {
            min: SlTpUtils.calculateMinSlTpPercent(price, variableTickList, isBuy, isSl),
            max: SlTpUtils.calculateMaxSlTpPercent(price, variableTickList, isBuy, isSl),
            step: 0.01,
            precision: 2
        };
    }
    else {
        return getNumericParametersByOffsetType(offsetType, variableTickList);
    }
}
export function getNumericParametersByOffsetType(offsetType, variableTickList) {
    const max = NumericUtils.MAXVALUE;
    switch (offsetType) {
        case OffsetModeViewEnum.Ticks:
            return { min: 1, max, step: 1, precision: 0 };
        case OffsetModeViewEnum.TicksFractionalForForex:
            return { min: 0.1, max, step: 0.1, precision: 1 };
        case OffsetModeViewEnum.Points: {
            const variableTick = variableTickList[0];
            return {
                min: variableTick.LeftBorder,
                max,
                step: variableTick.PointSize,
                precision: MathUtils.GetDecimalPlaces(variableTick.PointSize)
            };
        }
    }
}
